module.exports = "/_next/static/images/og-sistema-ru-bf08e25d877625115a71dc96af7805d2.jpg";